import { getOneOnOneSettingsPageApi, setOneOnOneSettingsPageApi } from '../apis';

export const getOneOnOneSettingsPageData = async () => {
  try {
    const res = await getOneOnOneSettingsPageApi();
    const data = res.entity as {
      isRatingEnabled: boolean;
      includeTranscriptionBot: boolean;
      isCarryForwardAgenda: boolean;
    };
    return data;
  } catch (error) {
    console.error('Error while fetching one-on-one settings', error);
  }
};

export const setOneOnOneSettingsPageData = async ({
  isRatingEnabled,
  includeTranscriptionBot,
  isCarryForwardAgenda,
}: {
  isRatingEnabled: boolean;
  includeTranscriptionBot: boolean;
  isCarryForwardAgenda: boolean;
}) => {
  try {
    const res = await setOneOnOneSettingsPageApi({
      isRatingEnabled,
      includeTranscriptionBot,
      isCarryForwardAgenda,
    });
  } catch (error) {
    console.error('Error while setting one-on-one settings', error);
  }
};
